<template>
  <div id="contenedor-principal-firmasadministracion" style="position:relative;">
    <div id="contenedor-encabezados-firmasadministracion" class="text-left">
      <h1>Administración de firmas</h1>
      
    </div>
    <div id="contenedor-principal-firmasadministracion" class="row mt-3">
      <!-- Filtro de Búsqueda -->
      <transition name="fade">
      
      <div v-show="(!mostrarFormularioEdicionFirma)"  id="contenedor-filtros-firmasadministracion" class="col-12 col-sm-12 col-md-12 col-lg-4 col-xlg-4">
      <div v-bind:class="[(mostrarFormularioEdicionFirma)? 'wrapDivBloqueado': '']">
       <div v-bind:class="[(mostrarFormularioEdicionFirma) ? 'area_verde bloquearDiv': 'area_verde']">
        
        <div >
       
            <FiltroDeBusquedaFirmas 
                :catalogos="catalogos" 
                :elementosAOmitir ="elementosAOmitir"
                :elementosAConservar ="elementosAConservar"
                :key="'filtro'+contrenderfiltros"
                :AccionesMostrar="comportamientoFiltroDeBusquedaFirmas"
                :ejecutalimpiarTablaResultados="limpiarTablaResultados" 
                :ejecutaLaFuncion="buscarProcesadoAPI"
                :area="obtenerAreaDeUsuario"
                :tituloDeBusqueda="'Búsqueda del procesado a administrar la firma'"
                :tituloDeSeleccione="'Ingrese de forma opcional alguna de las siguientes entradas:'"              
                :ref="'filtroBusqueda'">
            </FiltroDeBusquedaFirmas>
      
          </div>
        </div>
      
        </div>             
      </div>
      </transition>
      <!-- Tabla de resultados  -->
      <div v-bind:class="[(mostrarFormularioEdicionFirma) ? 'col-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12':'col-12 col-sm-12 col-md-12 col-lg-8 col-xlg-8  pt-sm-4 pt-md-4 pt-lg-0 pt-xlg-0']" id="ProcesadosEncontrados_div">
        <div class="area_verde">
          <transition name="fade">

          <div v-if="(firmas == undefined || firmas == null || firmas.length <= 0) && (!mostrarFormularioEdicionFirma)" style="background-color:var(--gris-pj); padding: 8px;">

            <div class="d-flex justify-content-center">
              <i class="fas fa-hand-paper mr-sm-2" style="font-size: 25px;"></i>
              <div class="align-content-center">
                <h5>Firmas a encontrar</h5>
                <!-- Esto es lo que se muestra antes de la busqueda -->
              </div>
            </div>
          </div>
          <TablaDeResultadosFirmas 
            v-else-if="firmas != undefined && firmas != null"
            v-show="(!mostrarFormularioEdicionFirma)"
            v-on:valorParaElPadreAccion="accionRealizar"
            :AccionesMostrar="accionesdelaTablaDeResultadosFirmas"
            :TablaFirmas="firmas">
          </TablaDeResultadosFirmas>
          </transition>


          <transition name="fade">
          <EdiciondeFirma 
            v-if="mostrarFormularioEdicionFirma"          
            :EdiciondeFirmas="Firma"
            :tituloDeInformacion="'Edición de firma'"
            :elementosAConservar ="elementosAConservar"
            :elementosAOmitir ="elementosAOmitir"
            v-on:guardar2="guardarEdicionFirmaAPI"
            v-on:restablecervalores="restablecerValoresDespuesDeGuardarOEliminar"
            v-on:botoncancelar2="restablecerVistaFirmas"
            :ref="'informacionEdicionFirma'">
          </EdiciondeFirma>
          </transition>
          

        </div>


        


      </div> 




    </div>
    
  </div>
</template>

<script>
import TablaDeResultadosFirmas from '@/components/SIVAC/Comun/TablaDeResultadosFirmas'
import FiltroDeBusquedaFirmas from '@/components/SIVAC/Comun/FiltroDeBusquedaFirmas'
import EdiciondeFirma from '@/components/SIVAC/Firmas/EdiciondeFirma'
import enumeraciones from '@/../static/js/enumeraciones'
import comun from "@/../static/js/comun"
import api from '@/../static/js/api'
import axios from 'axios'





export default {
    components: {
      FiltroDeBusquedaFirmas,
      TablaDeResultadosFirmas,
      EdiciondeFirma
    },
    
    data(){
      return{
          enumeraciones,
          tituloDeRecibodeFirma:'',
          mostrarFormularioEdicionFirma:false,
          accionesdelaTablaDeResultadosFirmas:{
          alta: false,
          impresion: false,
          cambios: true,
          visualizacion: true,
          altamanual: false,
          bajapersona: true,
          mensaje: false,
          verificarregistro: false,
          output: null,
          mensajeDeAlerta: true,
          mensajeDeAlertaError: true,
          mostrarcatalogocompleto: true
        },

        comportamientoFiltroDeBusquedaFirmas:{            
          administracion: true,
          consulta: false,
          mostrarFiltroCompleto: true
        },

        catalogos: [          
          { catalogoId: enumeraciones.catalogos.PartidosJudiciales, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_PartidoJudicial' },
          { catalogoId: enumeraciones.catalogos.Juzgados, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Area' },
          { catalogoId: enumeraciones.catalogos.Materias, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Materia' },
          { catalogoId: enumeraciones.catalogos.TiposDeDocumentos, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_TipoDocumento' },
          { catalogoId: enumeraciones.catalogos.Consecutivo, idDelInput: 'filtroDeBusqueda_Consecutivo_Firmas' },          
          { catalogoId: enumeraciones.catalogos.NumeroExtra, idDelInput: 'filtroDeBusqueda_NoExtra_Firmas' },
          { catalogoId: enumeraciones.catalogos.Delitos, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Delito' }
        ],
        elementosAOmitir: {
           
        },
        firmas: null,
        Firma: null,

        elementosAConservar: {

          tiposestatusfirma: [1,3],
          tiposDocumento: [1,5,23,27],
           areas: [12,95,54],
           partidosJudiciales: [1],
           materias: [6,9],
           entidades: [1],


        },

        contrenderfiltros: 0,


         actualizoarea: false,


      }
    },


    computed:{

      // elementosAConservar : function()
      // {
      //   let ep = {  
      //      tiposestatusfirma: [1,3],
      //      tiposDocumento: [1,5],
      //      areas: [12,95],
      //      partidosJudiciales: [1],
      //      materias: [6],
      //      entidades: [1],
           
      //   }

      //   // console.log(ep);


      //   return ep;

      // },


      /**
       * Funcion encargadas de obtener area del usuario de store.
       */
      obtenerAreaDeUsuario() {

          
        return this.$store.getters.Get_AreaDelUsuario;




      }






    },



    watch: {
        '$store.getters.Get_AreaDelUsuario': function() {
            
            //console.log("entro en watch", this.$store.getters.Get_AreaDelUsuario);


            if(!this.actualizoarea){

              if((this.$store.getters.Get_AreaDelUsuario==null || this.$store.getters.Get_AreaDelUsuario==undefined) || (this.$store.getters.Get_AreaDelUsuario.AreaId==112) ||  (this.$store.getters.Get_AreaDelUsuario.AreaId==1)){


               // this.elementosAConservar= null;
                
                this.actualizoarea= true;

                

              }

              this.contrenderfiltros++;




            }
        }
    },



    methods: {
    /** 
     * Metodo encargado de llamar API para búscar Firmas en base a los datos proporcionados.
     */
      buscarProcesadoAPI:function() 
      { 
        const parametros = 
        {    
                                       
          EsPrueba: this.enumeraciones.EsPrueba,
          
          Nombre:  this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].nombre) ? this.$refs['filtroBusqueda'].nombre : null,
          ApellidoPaterno: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].apellido_paterno) ? this.$refs['filtroBusqueda'].apellido_paterno : null,
          ApellidoMaterno: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].apellido_materno) ? this.$refs['filtroBusqueda'].apellido_materno : null,
          ClaveDelProcesado: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].clave_del_procesado) ? this.$refs['filtroBusqueda'].clave_del_procesado : null,


          PartidoJudicialId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_PartidoJudicial.partidoJudicialId) ? this.$refs['filtroBusqueda'].parametros_PartidoJudicial.partidoJudicialId : null,
          MateriaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_Materia.materiaId) ? this.$refs['filtroBusqueda'].parametros_Materia.materiaId : null,
          AreaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_Area.areaId) ? this.$refs['filtroBusqueda'].parametros_Area.areaId : null,
          TipoDeDocumentoId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_TipoDocumento.tipoDocumentoId) ? this.$refs['filtroBusqueda'].parametros_TipoDocumento.tipoDocumentoId : null,
          Consecutivo: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].consecutivo) ? this.$refs['filtroBusqueda'].consecutivo : null,
          NumeroRomano: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].numeroRomano) ? this.$refs['filtroBusqueda'].numeroRomano : null

        }
        // if(this.validarDatosBusquedaProcesado(parametros))
        // {
          comun.SeEstaCargandoInformacion(true); 
          const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);        

          axios.post(api.conexion + api.SIVAC.sistema.administracion.firmas.BuscarProcesadosParaFirmar, parametros, headerPeticion)
          .then(respuesta => {
            comun.SeEstaCargandoInformacion(false);
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              this.limpiarTablaResultados();
              if(this.mensajeDeAlertaError!=false){
                comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
              }
              this.mensajeDeAlertaError=true;
              
            } else {
              //Cargar Datos de Procesados
              this.firmas = respuesta.data.Firmas;
              this.$nextTick(()=> { PaginarTabla('tablaDeProcesadosParaFirma_table', 10)});
              // if(this.mensajeDeAlerta!=false){
              //   comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
              // }
              // this.mensajeDeAlerta=true;
              
            }         
          })
          .catch(e => {
            comun.SeEstaCargandoInformacion(false);
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
        // }
      },

             /** 
       * Metodo encargado de activar la vista de la edición del estatus de la firma.
       */
      edicionFirma:function()
      {
       
       this.mostrarFormularioEdicionFirma= true;
      
      },





      validarDatosBusquedaProcesado: function(datos)
      {
        if( (datos.ClaveDelProcesado == null || datos.ClaveDelProcesado == undefined) &&
            (datos.Nombre == null || datos.Nombre == undefined) && 
            (datos.ApellidoPaterno == null || datos.ApellidoPaterno == undefined) && 
            (datos.ApellidoMaterno == null || datos.ApellidoMaterno == undefined)
        )
        {          
            comun.mensajeDeAlerta("Favor de llenar por lo menos un campo del formulario.", null, null);
            return false;
        }
        return true;
       },
       /** 
       * Metodo encargado de verificar que el campo proporcionado tenga un valor valido
       * @param {string/int/other} campo [campo]
       */
      campoRequeridoEsValido: function(campo) 
      {
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      },
       /** 
       * Metodo encargado de limpiar los valores de la tabla de resultados.
       */
      limpiarTablaResultados: function()
      {
        this.firmas = null;
      },


      /** 
       * Metodo encargado de limpiar los valores de Firma.
       */
      limpiarValores: function()
      {
        
        this.Firma = null;
        
      },



      /** 
       * Metodo encargado de habilitar los componentes de acuerdo a la acción seleccionada (alta, impresion, alta manual, baja procesado)
       * en la tabla de resultados.
       * @param {object} datos [datos: Accion{Alta, Impresión, Alta Manual y Baja Procesado}]
       */
      accionRealizar:function(datos)
      {
        this.limpiarValores();
        //Asignar un id para mostrar los valores en una vista
        this.Firma = Object.assign({}, datos.Firma);

        

       



        //Editar información del estatus de la firma
        if(datos.Accion.Cambios)
        {
          
          this.edicionFirma();
        }


        
        else if(datos.Accion.BajaPersona)
        {
          

        var locale = {
        OK: '<i class="fa fa-check"></i>&nbsp;&nbsp;OK',
        CONFIRM: '<i class="fa fa-check"></i>&nbsp;&nbsp;Dar de baja al procesado de Firmas',
        CANCEL: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
         };
            
       bootbox.addLocale('custom', locale);




          bootbox.prompt({
            title: "Mensaje del sistema",
            message: "Está por dar de baja al procesado de Firmas.<br /> <br /> Nota: esto es cuando se manda un oficio para dar de baja a la persona de parte del juzgado <br /> <br />Ingrese el motivo de la baja:",


            locale: 'custom',
            
            
            callback: (respuestaContinuar) => {
              if (respuestaContinuar) {
                // console.log('This was logged in the callback: ' + respuestaContinuar);
                this.DarDeBajaAPI(respuestaContinuar);
              }
            }
          });
        }



      },



            /** 
       * Metodo encargado de llamar a API para editar una firma
       
       */
      guardarEdicionFirmaAPI:function(respuestaContinuar)
      {
        comun.SeEstaCargandoInformacion(true); 

        //Contruir petición y header
        
        let peticion = {
          EsPrueba: this.enumeraciones.EsPrueba,
          FirmaId: this.Firma.FirmaId,
          ProcesadoId: this.Firma.ProcesadoId,
          TipoEstatusFirmaId: this.$refs['informacionEdicionFirma'].tipoEstatusFirmaId,

          BitacoraMovimientos:{

           
            MotivoMovimiento: respuestaContinuar
            

          }


        };
        const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);  

        //Llamado a API
        axios.post(
          api.conexion + api.SIVAC.sistema.administracion.firmas.EdicionEstatusFirma, 
          peticion, 
          headerPeticion)
        .then(respuesta => {
          comun.SeEstaCargandoInformacion(false);
          if (respuesta.data.SiHayError) {
            console.log(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
          } else {
            this.restablecerValoresDespuesDeGuardarOEliminar();
            comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
          }            
        })
        .catch(e => {
          comun.SeEstaCargandoInformacion(false);
          console.log("No Hay Respuesta del Servidor" + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
        });
      },


                  /** 
       * Metodo encargado de llamar a API para dar de baja a un procesado
       */
      DarDeBajaAPI:function(respuestaContinuar)
      {
        comun.SeEstaCargandoInformacion(true); 

        //Contruir petición y header
        let peticion = {
          EsPrueba: this.enumeraciones.EsPrueba,
          FirmaId: this.Firma.FirmaId,
          ProcesadoId: this.Firma.ProcesadoId,
          // ExpedienteId: this.Firma.ExpedienteId,
          PersonaId: this.Firma.PersonaId,

          DelitosProcesados: this.Firma.DelitosProcesados,


          BitacoraMovimientos:{

           
            MotivoMovimiento: respuestaContinuar
            

          }

          


        }

        



        ;
        const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);  

        //Llamado a API
        axios.post(
          api.conexion + api.SIVAC.sistema.administracion.firmas.DarDeBajaProcesado, 
          peticion, 
          headerPeticion)
        .then(respuesta => {
          comun.SeEstaCargandoInformacion(false);
          if (respuesta.data.SiHayError) {
            console.log(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
          } else {
            this.restablecerValoresDespuesDeGuardarOEliminar();

            comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
          }            
        })
        .catch(e => {
          comun.SeEstaCargandoInformacion(false);
          console.log("No Hay Respuesta del Servidor" + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
        });
      },

           /** 
       * Metodo encargado de llamar a API para mandar un mensaje
       
       */
      guardarMensajeAPI:function()
      {
        comun.SeEstaCargandoInformacion(true); 

        //Contruir petición y header
        
        let peticion = {
          EsPrueba: this.enumeraciones.EsPrueba,
          FirmaId: this.Firma.FirmaId,
          MensajeProximaFirma: this.$refs['informacionMensaje'].mensaje
        };
        const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);  

        //Llamado a API
        axios.post(
          api.conexion + api.SIVAC.sistema.administracion.firmas.NuevoMensaje, 
          peticion, 
          headerPeticion)
        .then(respuesta => {
          comun.SeEstaCargandoInformacion(false);
          if (respuesta.data.SiHayError) {
            console.log(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
          } else {
            this.restablecerValoresDespuesDeGuardarOEliminar();
            comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
          }            
        })
        .catch(e => {
          comun.SeEstaCargandoInformacion(false);
          console.log("No Hay Respuesta del Servidor" + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
        });
      },




           /** 
       * Metodo encargado de llamar a API para generar una nueva firma con el dispositivo
       */
      VerificarRegistroDispositivoAPI:function()
      {
        comun.SeEstaCargandoInformacion(true); 

        //Contruir petición y header
        let peticion = {
          EsPrueba: this.enumeraciones.EsPrueba,
          FirmaId: this.Firma.FirmaId,
          ExpedienteId: this.Firma.ExpedienteId,
          PersonaId: this.Firma.PersonaId,
          ProcesadoId: this.Firma.Procesado.ProcesadoId,
          ClaveDelProcesado: this.Firma.Procesado.ClaveDelProcesado,
          Temporalidad: this.Firma.Procesado.TipoTemporalidadId,
          MensajeProximaFirma: this.Firma.MensajeProximaFirma,
          TipoEstatusMensajeId: this.Firma.TipoEstatusMensajeId


         // Nota: this.Firma.FirmaId viene de la tabla de resultados  y this.Firma es el objeto//

         


        };
        const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);  

        //Llamado a API
        axios.post(
          api.conexion + api.SIVAC.sistema.firmas.firmasmodulo.VerificarRegistroDispositivo, 
          peticion, 
          headerPeticion)
        .then(respuesta => {
          comun.SeEstaCargandoInformacion(false);
          if (respuesta.data.SiHayError) {
            console.log(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
          } else {
            // this.restablecerValoresDespuesDeGuardarOEliminar();

            comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
          }            
        })
        .catch(e => {
          comun.SeEstaCargandoInformacion(false);
          console.log("No Hay Respuesta del Servidor" + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
        });
      },






      /**
         * Función encargada de restablecer los valores de la pantalla
         */
      restablecerValoresDespuesDeGuardarOEliminar()
      {
        
        
        this.mostrarFormularioEdicionFirma= false;
        // this.mensajeDeAlerta= false;
        this.mensajeDeAlertaError= false;
        this.limpiarValores();
        this.limpiarTablaResultados();
        this.buscarProcesadoAPI();

      },


      restablecerVistaFirmas()
      {
       
        
        this.mostrarFormularioEdicionFirma= false;
       

      }











     }
    }

</script>

<style scoped>
  .bloquearDiv{
    pointer-events: none;
  }
  .wrapDivBloqueado
  {
    opacity: 0.7;
    cursor: not-allowed;
  }
  .fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.area_verde{
  background-color: var(--verde-pj);
    box-shadow: 0px 6px 20px 4px #161616;
    padding: 25px;
}
</style>


// WEBPACK FOOTER //
// src/components/SIVAC/Administracion/FirmasAdministracion.vue